<app-breadcrumb></app-breadcrumb>
<div class="container" *ngIf="theme$ | async as theme">
     <div class="main-container-faq">
          @for(groupedQuestion of faqGroupedQuestions; track $index) {
          <div class="section">
               <div class="category">{{groupedQuestion.category}}</div>
               <div class="accordion-container">
                    <p-accordion [value]="0" [dt]="faqAccordion">
                         @for(faq of groupedQuestion.faqs; track $index; let last = $last) {
                         <p-accordion-panel [value]="faq.id">
                              <p-accordion-header>
                                   <div class="flex flex-row align-items-center w-full">
                                        <span>{{faq.question}}</span>
                                   </div>
                              </p-accordion-header>
                              <p-accordion-content
                                   [style]="{'background': theme === 'light' ? 
                                   'var(--p-surface-0)' : 'var(--p-surface-50)'}">
                                   <div class="content-container">
                                        <div class="flex flex-column m-0">
                                             <p class="faq-description-text m-0">
                                                  {{faq.answer}}
                                             </p>
                                             <p class="ref-code-text">ref: {{faq.code}}</p>
                                             @if(faq.hasLink) {
                                                  <p class="button-container">
                                                       <button class="more-button" (click)="moreInfo(groupedQuestion.category, faq.code)">{{faq.linkTitle}}</button>
                                                  <p>
                                             }
                                        </div>
                                   </div>
                              </p-accordion-content>
                         </p-accordion-panel>
                         <div class="h-divider" *ngIf="!last"></div>
                         }
                    </p-accordion>
               </div>
          </div>
          }
     </div>
</div>